// extracted by mini-css-extract-plugin
export default {"button":"VendorLink_button__Y+nOU","img":"VendorLink_img__XXtf1"};